// Testimonials mobile carousel — per Martina, the stacked single-column
// layout ran too long on mobile/tablet (three tall Instagram-story photos
// plus their cards back to back). Replaced with a horizontal swipe
// carousel: native CSS scroll-snap does the actual scrolling (see the
// ≤960px block in styles.css — no GSAP/ScrollTrigger involved at all, on
// purpose, given how much of this page's mobile work has been about
// avoiding pin-based scroll mechanics on phones), this file just adds the
// optional arrows + dot indicators on top and keeps them in sync with
// whatever the user swipes to.
//
// Same breakpoint (960px) .testimonials__grid itself switches to a
// scroll-snap track at — re-checked on resize like cards-scroll.js's own
// mobileQuery, so crossing that line (rotating a tablet, resizing a
// browser window) toggles the carousel controls on/off correctly rather
// than getting stuck in whichever mode was active on load.
function initTestimonialsCarousel() {
  const grid = document.getElementById("testimonialsGrid");
  const nav = document.getElementById("testimonialsNav");
  const prevBtn = document.getElementById("testimonialsPrev");
  const nextBtn = document.getElementById("testimonialsNext");
  const dotsWrap = document.getElementById("testimonialsDots");
  if (!grid || !nav || !prevBtn || !nextBtn || !dotsWrap) return;

  const cards = Array.from(grid.querySelectorAll(".testimonials__col"));
  const dots = Array.from(dotsWrap.querySelectorAll(".testimonials__dot"));
  if (!cards.length || cards.length !== dots.length) return;

  const mobileQuery = window.matchMedia("(max-width: 960px)");
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  let current = 0;
  let scrollTimer;
  let bound = false;

  function scrollHandler() {
    clearTimeout(scrollTimer);
    // Debounced rather than driven off every scroll frame — the active
    // dot only needs to catch up once the swipe settles, not track the
    // gesture in real time, and this is far cheaper during a fast swipe.
    scrollTimer = setTimeout(updateActiveFromScroll, 100);
  }

  // Finds whichever card's start edge is currently closest to the
  // track's own start edge — with scroll-snap-align:start, that's
  // exactly the card the browser has (or is settling toward) snapped to.
  // Reading real layout instead of computing from scrollLeft/card widths
  // directly sidesteps having to duplicate the gap/padding math CSS
  // already owns.
  function closestIndex() {
    const gridRect = grid.getBoundingClientRect();
    let best = 0;
    let bestDist = Infinity;
    cards.forEach((card, i) => {
      const dist = Math.abs(card.getBoundingClientRect().left - gridRect.left);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });
    return best;
  }

  function updateActiveFromScroll() {
    setActive(closestIndex());
  }

  function setActive(index) {
    current = index;
    dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === cards.length - 1;
  }

  function goTo(index) {
    const clamped = Math.max(0, Math.min(cards.length - 1, index));
    cards[clamped].scrollIntoView({
      behavior: reduceMotion ? "auto" : "smooth",
      inline: "start",
      block: "nearest",
    });
    // scrollIntoView triggers the scroll listener asynchronously as the
    // browser catches up — setting state immediately too so the dot/arrow
    // feedback feels instant on tap rather than waiting for the debounce
    // above to notice.
    setActive(clamped);
  }

  function bindOnce() {
    if (bound) return;
    bound = true;
    prevBtn.addEventListener("click", () => goTo(current - 1));
    nextBtn.addEventListener("click", () => goTo(current + 1));
    dots.forEach((dot, i) => dot.addEventListener("click", () => goTo(i)));
    grid.addEventListener("scroll", scrollHandler, { passive: true });
  }

  function sync() {
    if (mobileQuery.matches) {
      bindOnce();
      setActive(closestIndex());
    }
    // No unbind branch needed at desktop widths: .testimonials__nav is
    // display:none there (styles.css), so the now-hidden buttons simply
    // can't be clicked — nothing to tear down.
  }

  sync();

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sync, 150);
  });

  // Console-inspectable state, same idea as window.__debugDevice.
  window.__debugTestimonials = {
    get current() {
      return current;
    },
    cards,
    goTo,
  };
}

initTestimonialsCarousel();
